import React from "react";
// This function takes as args a project name id and the index of selected project and returns the index of selected page in localeStorage data
function returnIndexOfPageName(targetPageId, selectedProject) {
    const tempData = JSON.parse(localStorage.getItem('data'))[selectedProject].pages;
  
    let indexTargetPage = -1;
  
    tempData.forEach((page, index) => {
      if (page.pageId === targetPageId) {
        indexTargetPage = index;
      }
    });
  
    return indexTargetPage;
}

const initCanvas = (nodesWidth,nodesHeight,colorFlows,nodes,setElements,setInitElements) => {

  const selectedPage = JSON.parse(localStorage.getItem('selectedPage'));
  const selectedProject = JSON.parse(localStorage.getItem('selectedProject'));

  if (selectedPage > -1 && selectedProject > -1) {
    const tempPages = JSON.parse(localStorage.getItem('data'))[selectedProject].pages;
    const tempElements = [];
    let indexCurrentPage = -1;
    

    tempPages.forEach((page, index) => {
      if (index === selectedPage) {
        indexCurrentPage = index;
        tempElements.push({
          id: (index + 1).toString(),
          data: {
            label: (
              <div className="react-flow-node1">
                <div className="dot-row">
                  <span className="dot" />
                  <span className="dot" />
                  <span className="dot" />
                </div>
                <div className="react-flow-inside-box">
                  {' '}
                  {
                    JSON.parse(localStorage.getItem('data'))[selectedProject].pages[selectedPage].name
                  }
                </div>
              </div>
            )
          },
          position: { x: 0, y: 0 },
          targetPosition: 'top',
          sourcePosition: 'top'
        });
      }
    });

    if (nodes.length > 0) {
      tempElements.push({
        id: '0',
        data: {
          label: (
            <div className="react-flow-node2">
              <div className="dot-row">
                <span className="dot" />
                <span className="dot" />
                <span className="dot" />
              </div>
              <div className="react-flow-inside-box"> Href</div>
            </div>
          )
        },
        position: { x: -400, y: 0 },
        targetPosition: 'top',
        sourcePosition: 'top'
      });

      let count = 1;
      const sumPages = JSON.parse(localStorage.getItem('data'))[selectedProject].pages.length - 1;

      const distanceX = sumPages * 168 + (sumPages - 1) * 20;

      tempPages.forEach((page, index2) => {
        if (index2 !== selectedPage) {
          count += 1;
          const corX = -distanceX / 2 + (count - 2) * 168 + (count - 2) * 20;
          tempElements.push({
            id: (index2 + 1).toString(),
            data: {
              label: (
                <div className="react-flow-node1">
                  <div className="dot-row">
                    <span className="dot" />
                    <span className="dot" />
                    <span className="dot" />
                  </div>
                  <div className="react-flow-inside-box">
                    {' '}
                    {JSON.parse(localStorage.getItem('data'))[selectedProject].pages[index2].name}
                  </div>
                </div>
              )
            },
            position: { x: corX + 84, y: 300 },
            targetPosition: 'top',
            sourcePosition: 'top'
          });
        }
      });

      const countOutPerPage = {};
      let countOutTargets = 0;

      const pageActions = JSON.parse(localStorage.getItem('data'))[selectedProject].pages[selectedPage].actions;

      if (pageActions !== undefined) {
        pageActions.forEach((action) => {
          
          const indexTargetPage = (action.internalAction !== undefined ? returnIndexOfPageName(
            action.internalAction.changePage,
            selectedProject
          ) : -1);

          if (indexTargetPage > -1 && indexTargetPage !== indexCurrentPage) {
            if (countOutPerPage[indexTargetPage] === undefined) {
              countOutPerPage[indexTargetPage] = 1;
            } else {
              countOutPerPage[indexTargetPage] += 1;
            }
            countOutTargets += 1;

            const stroke = colorFlows[0];
            
            let text = '';
            
            if( action.UIProps.type !== ''){
              text = `${action.UIProps.id  } : ${action.UIProps.type}`;
            }
            else{
              text = `${action.UIProps.id  } : undefined`;
            }
          
            tempElements.push({
              id: `eOut${  countOutTargets.toString()}`,
              source: (indexCurrentPage + 1).toString(),
              target: (indexTargetPage + 1).toString(),
              type: 'customDown',
              data: {
                text,
                distance: (countOutPerPage[indexTargetPage] - 1) * 50,
                stroke,
                positionStart: 'bottom',
                positionTarget: 'top',
                nodesWidth,
                nodesHeight
              },
              arrowHeadType: 'arrowclosed'
            });
          } else if (
            action.externalAction.linkHref !== '' &&
            action.externalAction.linkHref !== '#'
          ) {
            if (countOutPerPage[0] === undefined) {
              countOutPerPage[0] = 1;
            } else {
              countOutPerPage[0] += 1;
            }

            const stroke = colorFlows[1];
            
            let text = '';

            if( action.UIProps.type !== ''){
              text = `${action.UIProps.id  } : ${action.UIProps.type} , href : ${  action.externalAction.linkHref}`;
            }
            else{
              text = `${action.UIProps.id  } : undefined , href : ${  action.externalAction.linkHref}`;
            }

            countOutTargets += 1;
            tempElements.push({
              id: `eOut${  countOutTargets.toString()}`,
              source: (indexCurrentPage + 1).toString(),
              target: '0',
              type: 'customDown',
              data: {
                text,
                distance: (countOutPerPage[0] - 1) * 50,
                stroke,
                positionStart: 'left',
                positionTarget: 'right',
                nodesWidth,
                nodesHeight,
                isHref: true
              },
              arrowHeadType: 'arrowclosed'
            });
          } else if (
            action.service !== undefined &&
            action.service.url !== undefined &&
            action.service.url !== ''
          ) {
            if (countOutPerPage[100] === undefined) {
              countOutPerPage[100] = 1;
            } else {
              countOutPerPage[100] += 1;
            }

            const stroke = colorFlows[2];
            const text =
              `${action.UIProps.id 
              } : ${ 
              action.UIProps.tagName 
              } ,type request : ${ 
              action.service.typeRequest 
              } ,url : ${ 
              action.service.url}`;

            countOutTargets += 1;
            tempElements.push({
              id: `eOut${  countOutTargets.toString()}`,
              target: (indexCurrentPage + 1).toString(),
              source: '0',
              type: 'customUp',
              data: {
                text,
                distance: countOutPerPage[100] * 50,
                stroke,
                positionStart: 'right',
                positionTarget: 'left',
                nodesWidth,
                nodesHeight,
                isService: true
              },
              arrowHeadType: 'arrowclosed'
            });
          }
        });
      }

      const pagesData = JSON.parse(localStorage.getItem('data'))[selectedProject];
      let countInTargets = 0;

      pagesData.pages.forEach((page, index) => {
        if (index !== selectedPage) {
          let countInPerPage = 0;

          if (page.actions !== undefined) {
            page.actions.forEach((action) => {
              
              const indexTargetPage = ( action.internalAction !== undefined ? returnIndexOfPageName(
                action.internalAction.changePage,
                selectedProject
              ) : -1);
              if (indexTargetPage === indexCurrentPage) {
                countInPerPage += 1;
                countInTargets += 1;

                const stroke = colorFlows[0];
                let text = '';

                if( action.UIProps.type !== ''){
                  text = `${action.UIProps.id  } : ${action.UIProps.type}`;
                }
                else{
                  text = `${action.UIProps.id  } : undefined`;
                }
              
                tempElements.push({
                  id: `eIn${  countInTargets.toString()}`,
                  source: (index + 1).toString(),
                  target: (indexCurrentPage + 1).toString(),
                  type: 'customUp',
                  data: {
                    text,
                    distance: countInPerPage * -50,
                    stroke,
                    positionStart: 'top',
                    positionTarget: 'bottom',
                    nodesWidth,
                    nodesHeight
                  },
                  arrowHeadType: 'arrowclosed'
                });
              }
            });
          }
        }
      });
    }

    setElements(tempElements);
    setInitElements(true);
  }

}

export default initCanvas;